// =============================================================================
// Configuración de entorno (hallazgo S4)
// -----------------------------------------------------------------------------
// Vue CLI inyecta en build-time las variables `VUE_APP_*` definidas en los
// archivos `.env*`. Documentar las variables disponibles en `.env.example`.
//
// ⚠️ SEGURIDAD: cualquier variable `VUE_APP_*` queda incrustada en el bundle
// final y es PÚBLICA. Aquí NO debe vivir ningún secreto (claves, tokens).
// =============================================================================


/* export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || 'https://api.nexuscredit.net/index.php/';

export const API_ORIGIN =
  process.env.VUE_APP_API_ORIGIN || 'https://api.nexuscredit.net'; */



export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || 'http://devapi.nexuscredit.net/index.php/';

export const API_ORIGIN =
  process.env.VUE_APP_API_ORIGIN || 'http://devapi.nexuscredit.net/';

// Versión del build (inyectada por vue.config.js). El API la compara por
// igualdad exacta para bloquear frontends desactualizados (HTTP 426).
export const APP_VERSION =
  process.env.VUE_APP_BUILD_VERSION || '0.3.4';
